require('./globalPositionSavings.scss');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const get = require('lodash/object/get');
const { formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const GlobalPositionFinancialCard = require('components/globalPosition/globalPositionFinancialCard/globalPositionFinancialCard');
const { PLURAL_CHARACTER } = require('constants/index');
const classnames = require('classnames');
const includes = require('lodash/collection/includes');
const some = require('lodash/collection/some');

function getCurrencyDetail(content) {
    const available = get(content, 'totalAvailableBalance', []).map(currencyContent => {
        return {
            currency: currencyContent.currency,
            amount: currencyContent.amount,
            legend: formatText('myGlobalPosition-savingsTotal')
        };
    });

    return available;
}

function getSavings(content) {
    if (!content) return [];
    return get(content, 'data', []).map(savings => {
        const depositId = getLastNChars(savings.contractNumber);
        const depositLink = `/myprofile/deposits/${savings.id}`;

        return {
            title: savings.alias,
            titleSmall: depositId,
            amount: get(savings, 'totalAvailableBalance.amount'),
            currency: get(savings, 'totalAvailableBalance.currency'),
            link: depositLink
        };
    });
}

class GlobalPositionSavings extends React.Component {
    constructor(props) {
        super(props);
        this.handleBoxClick = this.handleBoxClick.bind(this);
    }

    handleBoxClick(evt) {
        const linkToDepositsView = '/myprofile/deposits';
        const classListWithoutRedirect = [
            'ok-collapsing-toggler'
        ];
        if (!some(evt.target.parentElement.classList, (el) => includes(classListWithoutRedirect, el))) {
            this.props.history.push(linkToDepositsView);
        }
    }

    render() {
        const { expanded, immSavings } = this.props;
        const excludedItems = immSavings.get('excludedSavings');
        const hasExcludedItems = excludedItems > 0;
        const content = immSavings.toJSON();
        const currencyDetails = getCurrencyDetail(content);
        const savings = getSavings(content);
        const link = '/myprofile/deposits';
        const pluralPostfix = excludedItems !== 1 ? PLURAL_CHARACTER : '';
        const subtitle = hasExcludedItems ? formatText('myGlobalPosition-excludedSavings', [excludedItems, pluralPostfix, pluralPostfix]) : '';
        const financialSavingClass = classnames({
            'global-position-savings-section__subsection--is-clickable': !expanded
        });

        return (
            <div onClick={!expanded &&  this.handleBoxClick} className={financialSavingClass}>
                <GlobalPositionFinancialCard
                    id={this.props.id}
                    icon="rebrand-savings"
                    amount={savings.length}
                    cards={savings}
                    currencyDetails={currencyDetails}
                    showMoreText={formatText('myGlobalPosition-savingsShowMore')}
                    showMoreLink={link}
                    title={formatText('myGlobalPosition-savings')}
                    expanded={expanded}
                    titleLink={link}
                    subtitle={subtitle}
                    hasExcludedItems={hasExcludedItems}
                    allItemsExcluded={immSavings.get('data').size === 0}
                    emptyStateMessage={formatText('myGlobalPosition-allSavingsExcluded')}
                />
            </div>
        );
    }
}

GlobalPositionSavings.propTypes = {
    history: PropTypes.object.isRequired,
    immSavings: PropTypes.object.isRequired,
    expanded: PropTypes.bool,
    id: PropTypes.string
};

module.exports = withRouter(GlobalPositionSavings);
